import { gql } from "@outschool/ui-apollo";

const ContentfulSubjectSubcategoriesQuery = gql`
  query ContentfulTutoringPageSubjectSubcategories(
    $locale: String
    $preview: Boolean
    $subject: String!
  ) {
    contentfulTutoringPageCollection(
      limit: 1
      skip: 0
      preview: $preview
      locale: $locale
    ) {
      items {
        carouselSubcategoriesCollection(where: { subject: $subject }) {
          items {
            nameTitleCased
            slug
            subject
          }
        }
      }
    }
  }
`;

export default ContentfulSubjectSubcategoriesQuery;
